// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__xzSKL","name":"ConsentHeader_name__2ggQ1","birthday":"ConsentHeader_birthday__AxDoE","skeleton":"ConsentHeader_skeleton__3O_dk"};